module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-6-2b138a9eaca296f7b3ff93d0154aad58.jpg";